import { useEffect, useState, useCallback } from 'react';
import { APP_VERSION } from './version';

// Polling do endpoint /api/version do backend. A cada N min, compara
// a versao MAJOR do FE (APP_VERSION) com minFrontendVersion retornada
// pelo backend. Se o FE for mais antigo que o minimo aceito, marca
// como incompativel — o que dispara o banner critico de "atualize".
//
// Por que so MAJOR: por convencao semver, MINOR/PATCH sao retro-
// compativeis. So MAJOR indica breaking change na API. Se o BE pulou
// de 1.x pra 2.0, FE 1.x esta quebrado e precisa atualizar urgente.
//
// Endpoint pode ainda nao existir (backend rolando endpoint num PR
// separado). Falha silenciosa — info fica null e banner nao aparece.

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5min
const FIRST_CHECK_DELAY_MS = 30 * 1000; // 30s apos load

const parseMajor = (v) => {
  if (!v || typeof v !== 'string') return null;
  const major = parseInt(v.split('.')[0], 10);
  return Number.isFinite(major) ? major : null;
};

export const useBackendVersion = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (APP_VERSION === 'dev') return undefined;

    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`/api/version?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const body = await res.json();
        if (cancelled) return;

        // Backend Higra serve respostas wrappadas em ResponseResultDTO
        // ({ statusCode, data }). Desembrulha aqui — codigo de
        // consumo segue plano.
        const data = body && body.data ? body.data : body;

        const feMajor = parseMajor(APP_VERSION);
        const minMajor = parseMajor(data.minFrontendVersion);
        const incompatible =
          feMajor != null &&
          minMajor != null &&
          minMajor > 0 &&
          feMajor < minMajor;

        setInfo({
          backendVersion: data.version || null,
          minFrontendVersion: data.minFrontendVersion || null,
          incompatible,
        });
      } catch (_) {
        // Endpoint indisponivel / 404 / rede. Falha silenciosa —
        // sera retentado no proximo tick.
      }
    };

    const firstTimer = setTimeout(check, FIRST_CHECK_DELAY_MS);
    const intervalTimer = setInterval(check, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearTimeout(firstTimer);
      clearInterval(intervalTimer);
    };
  }, []);

  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    backendVersion: info?.backendVersion || null,
    minFrontendVersion: info?.minFrontendVersion || null,
    incompatible: info?.incompatible || false,
    reload,
  };
};
